import { render, staticRenderFns } from "./device-on-off-install.vue?vue&type=template&id=48a89a1c&"
import script from "./device-on-off-install.js?vue&type=script&lang=js&"
export * from "./device-on-off-install.js?vue&type=script&lang=js&"
import style0 from "./device-on-off-install.css?vue&type=style&index=0&scope=true&lang=css&"
import style1 from "./device-on-off-install-vuetify.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports